<script>
  export let size = 30;
  export let color = '#0a1542';
</script>


<div
  class="loader"
  style="
    border-width: {Math.ceil(size/5)}px;
    width: {size}px;
    height: {size}px;
    border-top-color: {color};"
></div>


<style>
  .loader {
    margin: auto;
    border-color: #e2e4e9;
    border-style: solid;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  @-webkit-keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
</style>
